"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const react_router_dom_1 = require("react-router-dom");
const store_1 = require("../../../store/store");
const appSlice_1 = require("../../../store/slices/appSlice");
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const LoginImage_1 = __importDefault(require("../../../components/LoginImage"));
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const LoginStep2 = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { user } = (0, store_1.useAppSelector)((state) => state.app);
    const [error, setError] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [redirect, setRedirect] = (0, react_1.useState)(null);
    const handleSubmit = (values) => {
        setIsLoading(true);
        axios
            .post('/api/auth/login/step-2', values)
            .then((response) => response.data)
            .then((data) => {
            if (data.success) {
                setIsLoading(false);
                dispatch((0, appSlice_1.setUser)(data.user));
            }
            else {
                setIsLoading(false);
                setError(data.message);
            }
        })
            .catch((error) => {
            var _a;
            setIsLoading(false);
            if (error.status === 401) {
                setError(__.trans('login.step-2-unauthenticated'));
                setRedirect(setTimeout(() => navigate('/auth/login'), 3000));
            }
            else {
                setError((_a = error.data.replyStatus) === null || _a === void 0 ? void 0 : _a.errorMessage);
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);
    (0, react_1.useEffect)(() => {
        return () => {
            setError(null);
            if (redirect) {
                clearTimeout(redirect);
            }
        };
    }, [redirect]);
    return ((0, jsx_runtime_1.jsxs)("div", { id: "login-view", children: [(0, jsx_runtime_1.jsxs)("div", { className: "login-container", children: [(0, jsx_runtime_1.jsx)("h5", { className: "form-title", children: __.trans('login.2factor-form-title') }), error && (0, jsx_runtime_1.jsx)("div", { className: "alert alert-danger", children: error }), (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: { password2: '' }, onSubmit: handleSubmit, validationSchema: yup.object().shape({
                            password2: yup.string().required(__.trans('login.validation-2factor-required')),
                        }), children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'password2', id: 'password2', type: 'text', label: __.trans('login.one-time-code'), autoComplete: 'one-time-code' }), (0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn theme-button-primary mt-3 w-100", children: __.trans('login.2factor-form-submit') }) })] }) })] }), (0, jsx_runtime_1.jsx)(LoginImage_1.default, {})] }));
};
exports.default = LoginStep2;
